/**
* DevExpress Dashboard (_aria-live-region.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { format as stringFormat } from 'devextreme/core/utils/string';
import { getLocalizationById } from '../../data/index.internal';
class AriaLiveRegion {
    static updateLiveRegionByItem(dashboardItem) {
        let liveRegionContainer = document.getElementById(this._liveRegionElementId);
        if (!liveRegionContainer)
            return;
        let div = liveRegionContainer.querySelector(`#${dashboardItem._elementId}`);
        if (div)
            div.remove();
        div = document.createElement('div');
        div.setAttribute('id', dashboardItem._elementId);
        liveRegionContainer.appendChild(div);
        div.setAttribute('aria-label', stringFormat(getLocalizationById('DevExpressWebStringId.AriaLabel.DashboardItemUpdated'), `${dashboardItem.componentName()} - ${dashboardItem.name()}`));
    }
    static updateLiveRegion(message, isError) {
        let liveRegionContainer = document.getElementById(this._liveRegionElementId);
        if (!liveRegionContainer)
            return;
        let div = liveRegionContainer.querySelector(this._liveRegionNotifierElementId);
        if (div)
            div.remove();
        div = document.createElement('div');
        div.setAttribute('id', this._liveRegionNotifierElementId);
        liveRegionContainer.appendChild(div);
        div.setAttribute('aria-label', message);
        if (isError)
            div.setAttribute('aria-invalid', 'true');
    }
}
AriaLiveRegion._liveRegionElementId = 'dx-dashbaord-items-live-region-container';
AriaLiveRegion._liveRegionNotifierElementId = 'dx-dashboard-live-notificator';
export { AriaLiveRegion };
